import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import { V4A_NAMESPACE } from '../constants';

interface PauseChipProps {
  paused: boolean;
  onToggle: () => void;
  /** Accessible names, already translated: "Pausar a simulação de ping" / "Retomar a simulação de ping". */
  labelPause: string;
  labelResume: string;
  /** Nothing moves under reduced motion, so the control is not offered at all. */
  hidden?: boolean;
  /** The source sizes the glyphs 15px in the small chips and 16px in the band controls. */
  iconSize?: 15 | 16;
  className?: string;
  controls?: string;
  /** Visible verb while paused, when it is not the default "Retomar" (the videos say "Reproduzir"). */
  resumeText?: string;
}

/** Every WCAG 2.2.2 pause control on the page: a 44x44 hit area around a chip-sized pill. */
export function PauseChip({ paused, onToggle, labelPause, labelResume, hidden = false, iconSize = 15, className, controls, resumeText }: PauseChipProps) {
  const { t } = useTranslation(V4A_NAMESPACE);
  return (
    <button className={classNames('mochip min-h-11 min-w-11 flex-none items-center justify-center rounded-[var(--r-md)] border-0 p-0 [background:none]', className)} type='button' aria-pressed={paused} aria-label={paused ? labelResume : labelPause} aria-controls={controls} hidden={hidden} onClick={onToggle}>
      <span className='mochip__in inline-flex min-h-9 items-center gap-[.45rem] px-3 py-0 text-[length:var(--fs-xs)] font-semibold text-inherit'>
        <svg className='ic-pause' width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' aria-hidden='true' focusable='false'>
          <path d='M8.5 5.5v13M15.5 5.5v13' />
        </svg>
        <svg className='ic-play' width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='currentColor' aria-hidden='true' focusable='false'>
          <path d='M8 5.2v13.6a.8.8 0 0 0 1.2.7l11-6.8a.8.8 0 0 0 0-1.4l-11-6.8a.8.8 0 0 0-1.2.7z' />
        </svg>
        <span>{paused ? (resumeText ?? t('controls.resume')) : t('controls.pause')}</span>
      </span>
    </button>
  );
}
